const MOSCOW_UTC_OFFSET_MILLISECONDS = 3 * 60 * 60 * 1000;

export const formatReadOnlyModeStartsAt = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    return `${new Intl.DateTimeFormat('ru-RU', {
        timeZone: 'Europe/Moscow',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).format(date)} по мск`;
};

export const toMoscowDateTimeLocal = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    return new Date(date.getTime() + MOSCOW_UTC_OFFSET_MILLISECONDS)
        .toISOString()
        .slice(0, 19);
};

export const fromMoscowDateTimeLocal = (value) => {
    if (!value) return '';

    const valueWithSeconds = value.length === 16 ? `${value}:00` : value;
    return `${valueWithSeconds}+03:00`;
};
